module.exports = __webpack_public_path__ + "static/img/49031.1395f96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/49031.jpg
// module id = JRSy
// module chunks = 1